import { config } from '~app/config';

import { makeRequest } from '~shared/api/make-request';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { getDeviceInfo } from '@breezeventures/utils/get-metadata';
import { useMutation } from '@tanstack/react-query';

import type {
  PartnerApplicationResponse,
  UpdatePartnerApplicationRequest,
} from '../model';

export const useUpdatePartnerApplication = () => {
  return useMutation({
    mutationFn: (data: UpdatePartnerApplicationRequest) => {
      return makeRequest<ResponseSuccess<PartnerApplicationResponse>>({
        url: `${config.apiHost}/merchant-origination/api/v1/public/partner/applications/update`,
        credentials: 'include',
        payload: {
          ...data,
          deviceData: getDeviceInfo(),
        },
      }).then((response) => response.payload);
    },
  });
};
